import { Subject } from 'rxjs';
import { ListenStatement, Statement } from './type';
import {
  formatListenStatement,
  formatPosStatement,
  formatPosStatements,
  formatStatement,
  formatStatements,
} from './helps';
import sdkStatementService, {
  CardStatementOrderDto,
  FileFormat,
  PaginationRequest,
  PosTerminalStatementOrder,
  StatementOrder,
} from '@/app/graphql/statement/statement';

export const userListenStatementLine = new Subject<any>();
export async function findAllStatement(partyId: number, pagination: PaginationRequest) {
  const response = await sdkStatementService.findAll({ partyId, pagination });
  return {
    ...response.findAll,
    statements: formatStatements(response.findAll.statements),
  };
}

export async function getPosTerminals(partyID: number) {
  const response = await sdkStatementService.getPOSTerminals({ partyID });
  return response.getPOSTerminals;
}

export async function findPosStatements(partyId: number, pagination: PaginationRequest) {
  const response = await sdkStatementService.findPOSTerminalStatements({ partyId, pagination });
  return {
    ...response.findPOSTerminalStatements,
    posTerminalStatements: formatPosStatements(response.findPOSTerminalStatements.posTerminalStatements),
  };
}

export async function downloadFileStatement(fileFormat: FileFormat, statement: Statement) {
  const { fileName, partyId } = statement;
  const response = await sdkStatementService.download({ partyId, fileFormat, fileName });
  return response.download;
}

export async function downloadPosStatement(statement: Statement, fileFormat: FileFormat) {
  const { id: statementID, partyId: partyID } = statement;
  const response = await sdkStatementService.downloadPOSTerminalStatement({ statementID, partyID, fileFormat });
  return response.downloadPOSTerminalStatement;
}

export async function orderStatement(statementOrder: StatementOrder) {
  const response = await sdkStatementService.order({ statementOrder });
  return formatStatement(response.order);
}

export async function orderPosStatement(statementOrder: PosTerminalStatementOrder) {
  const response = await sdkStatementService.orderPOSTerminalStatement({ statementOrder });
  return formatPosStatement(response.orderPOSTerminalStatement);
}

export async function listenStatement(partyId: number): Promise<Function> {
  const subscribe = await sdkStatementService.listen({ partyId });
  // @ts-ignore
  const { unsubscribe } = subscribe((result: ListenStatement) => {
    const statement = result?.data?.listen;
    if (!statement) return;
    userListenStatementLine.next(formatListenStatement(statement.statement));
  });
  return unsubscribe;
}

export async function listenPosStatement(partyID: number): Promise<Function> {
  const subscribe = await sdkStatementService.listenPOSTerminalStatement({ partyID });
  // @ts-ignore
  const { unsubscribe } = subscribe((result: any) => {
    const statement = result?.data?.listenPOSTerminalStatement;
    if (!statement) return;
    userListenStatementLine.next({
      data: {
        listen: {
          statement: formatListenStatement(statement.posTerminalStatement),
          subscriptionType: statement.subscriptionType,
        },
      },
    });
  });
  return unsubscribe;
}

export async function orderCardStatement(statementOrder: CardStatementOrderDto) {
  const response = await sdkStatementService.orderCardStatement({ statementOrder });
  return response.orderCardStatement;
}
